import { createVanIconComponent } from "./van"

const Passed = createVanIconComponent("passed")
export default Passed
